import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { FeatureFlagsProps } from './featureFlagsTypes';

export const getFeatureFlags = createAction('GET_FEATURE_FLAGS', getPayloadCreator());
export const getFeatureFlagsSuccess = createAction('GET_FEATURE_FLAGS_SUCCESS', getPayloadCreator<FeatureFlagsProps>());
export const getFeatureFlagsFailure = createAction('GET_FEATURE_FLAGS_FAILURE', getPayloadCreator<any>());

export const applyFeatureFlagsChanges = createAction(
  'APPLY_FEATURE_FLAGS_CHANGES',
  getPayloadCreator<FeatureFlagsProps>(),
);
